module.exports = __webpack_public_path__ + "img/banner-product.d331250e.png";